/* eslint-disable react/prop-types */
import React from 'react';

import IconRating from '@zg-rentals/multibrand-ui/lib/IconRating';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import { COMMUNICATION_MAP } from './controller';
import './style.scss';

class EmojiRatingWithText extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      emojiDescription: COMMUNICATION_MAP[props.rating],
    };
  }

  handleStarClick = (emoji) => {
    this.setState({
      emojiDescription: COMMUNICATION_MAP[emoji],
    });

    this.props.onClick(emoji);
  };

  render() {
    const { emojiDescription } = this.state;
    const { rating } = this.props;

    return (
      <div className="EmojiRatingWithText">
        <div className="stacked-md">
          <IconRating size="36" initialRatingValue={Number(rating)} onClick={this.handleStarClick} />
        </div>
        <div className="stacked-md">
          <Text emphasize type="h2">
            {emojiDescription || '-'}
          </Text>
        </div>
      </div>
    );
  }
}

export default EmojiRatingWithText;
